import { BUMPS_FACE_LOCATIONS } from '@/modules/questionnaire/api/constants';

export const CAMEDO_LOCATIONS_OPTIONS = [
  { value: BUMPS_FACE_LOCATIONS.NOSE, text: 'faceZone.nose' },
  { value: BUMPS_FACE_LOCATIONS.CHEEKS, text: 'faceZone.cheeks' },
  { value: BUMPS_FACE_LOCATIONS.FOREHEAD, text: 'faceZone.forehead' },
  { value: BUMPS_FACE_LOCATIONS.CHIN, text: 'faceZone.chin' }
];
